import {ConnectBasicEntity} from '../../framework/message/ConnectBasicEntity';
import {ProcessFlow} from './ProcessFlow';
import {ProcessMappingStep} from './ProcessMappingStep';
import {ProcessReport} from './ProcessReport';
import {ProcessStep} from './ProcessStep';
import {ProcessWorkingTable} from './ProcessWorkingTable';

export class Process extends ConnectBasicEntity {
akmeEntity: string;
cron: string;
enqueue: boolean | null;
inCnxCode: string;
inParams: string;
inQuery: string;
inSchema: string;
inStoredProc: string;
inTable: string;
job: string;
jobName: string;
nextStartDate: number | null;
orderedMappingSteps: {[key: string]: ProcessMappingStep};
outAddHeader: boolean | null;
outAddWitness: boolean | null;
outCnxCode: string;
outData: string;
outFieldSeparator: string;
outFileExtension: string;
outFileFormat: string;
outFolder: string;
outMaxLines: number | null;
outParams: string;
outQuery: string;
outSchema: string;
outStoredProc: string;
outTable: string;
outUrl: string;
outUrlResponseCodeField: string;
outUrlResponseDescField: string;
paquetSize: number | null;
processFlows: {[key: string]: ProcessFlow};
processMappingSteps: {[key: string]: ProcessMappingStep};
processReports: {[key: string]: ProcessReport};
processSteps: {[key: string]: ProcessStep};
processWorkingTables: {[key: string]: ProcessWorkingTable};
reportExecution: boolean | null;
visionCode: string;
}

